import React from "react";
import { useLocation, matchPath, useHistory } from "react-router-dom";
import { Breadcrumb } from "antd";

type RouteConfig = {
  path: string;
  breadcrumb: string | ((params: Record<string, string>) => React.ReactNode);
};

const companyRoutes: RouteConfig[] = [
  { path: "/company/company-profile/", breadcrumb: "Min oversikt" },
  { path: "/company/company-profile/events/", breadcrumb: "Mine arrangementer" },
  { path: "/company/company-profile/jobs/", breadcrumb: "Mine stillingsannonser" },
  { path: "/company/company-profile/jobs/create-job-posting/", breadcrumb: "Opprett ny stillingsannonse" },
  { path: "/company/company-profile/jobs/:jobId/edit/", breadcrumb: "Rediger stillingsannonse" },
  { path: "/company/company-profile/edit-profile/", breadcrumb: "Rediger bedriftsprofil" },
  { path: "/company/company-profile/contact-persons/", breadcrumb: "Mine kontaktpersoner" },
  { path: "/company/company-profile/account/", breadcrumb: "Kontoinnstillinger" },
];

const findMatchingRoutes = (routes: RouteConfig[], pathname: string) => {
  return routes
    .map(route => {
      const match = matchPath(pathname, {
        path: route.path,
        exact: false,
      });
      if (
        match &&
        route.path === "/company/company-profile/events/:id/" &&
        (match.params as { id: string }).id === "new"
      ) {
        // Prevent matching /company-profile/events/new/ to /company-profile/events/:id/ with new as id
        return null;
      }
      return match ? { route, params: match.params } : null;
    })
    .filter((result): result is { route: RouteConfig; params: Record<string, string> } => result !== null);
};

const CompanyBreadcrumb: React.FC = () => {
  const location = useLocation();
  const history = useHistory();

  const matches = findMatchingRoutes(companyRoutes, location.pathname);

  const breadcrumbs = matches.map(({ route, params }) => {
    const breadcrumbName = typeof route.breadcrumb === "function" ? route.breadcrumb(params) : route.breadcrumb;
    const path = Object.keys(params).reduce(
      (resolvedPath, paramKey) => resolvedPath.replace(`:${paramKey}`, params[paramKey]),
      route.path
    );
    return { path, breadcrumbName };
  });

  return (
    <Breadcrumb style={{ marginBottom: "16px" }} separator=">">
      {breadcrumbs.map(breadcrumb => (
        <Breadcrumb.Item key={breadcrumb.path}>
          <span
            onClick={() => history.push(breadcrumb.path)}
            onKeyPress={e => {
              if (e.key === "Enter" || e.key === " ") {
                history.push(breadcrumb.path);
              }
            }}
            role="button"
            tabIndex={0}
            style={{ cursor: "pointer" }}
          >
            {breadcrumb.breadcrumbName}
          </span>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default CompanyBreadcrumb;
